import {Component, Input, inject} from '@angular/core';
import {Profile} from '../../_data/reports/business/request/business-services-order-data';
import {I18nService} from '../../_services/gui/i18n.service';
import {KeyValuePipe} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-owner-confirm',
    templateUrl: './owner-confirm.component.html',
    styleUrls: ['./owner-confirm.component.scss'],
    imports: [KeyValuePipe, TranslateModule]
})
export class OwnerConfirmComponent {

  @Input() profile: Profile;
  cardTypes: Map<string, string>;

  private i18nService = inject(I18nService);

  constructor() {
    const i18nService = this.i18nService;

    i18nService.cardTypes.subscribe(value => this.cardTypes = value);
  }
}
